import { Component, Input } from '@angular/core';

export const LVC_REQUEST_URL = 'https://goto/LVCrequest';

@Component({
    selector: 'lh-lvc-request-button',
    standalone: false,
    templateUrl: './lh-lvc-request-button.component.html',
    styleUrls: ['./lh-lvc-request-button.component.scss'],
})
export class LhLvcRequestButtonComponent {
    @Input() label: string = 'LVC Request';
    @Input() href: string = LVC_REQUEST_URL;
    @Input() tooltip: string = 'Open the LVC request form in a new tab';
}
